import API from '../../services/API';
import endpoints from '../../constants/configs/endpoints';
import { setError, startSpinner, stopSpinner } from '../../actions/common/actionCreators';
import { MANAGE_WORKGROUP_ACTION_TYPES } from '../../constants/actionTypes/manageWorkgroupTypes';
import { IS_DEFAULT_WORKGROUP, RESPONSE_STATUS } from '../../constants/ticketMgmt/manageWorkgroup.constants';

const actions = { setError, startSpinner, stopSpinner };

export const setManageWorkgroupDetails = data => ({
    type: MANAGE_WORKGROUP_ACTION_TYPES.SET_WORKGROUP_LIST,
    payload: data,
});

export const setWorkgroupAllTags = data => ({
    type: MANAGE_WORKGROUP_ACTION_TYPES.SET_WORKGROUP_ALL_TAGS,
    payload: data,
});

export const setSubmitWorkgroupListMsg = data => ({
    type: MANAGE_WORKGROUP_ACTION_TYPES.SET_WORKGROUP_SUBMIT_MSG,
    payload: data,
});

export const fetchManageWorkgroupDetails = () => async dispatch => {
    const url = endpoints.TICKET_MGMT_WORKGROUPS_LIST;
    const workgroupData = await API.getData(url, dispatch, actions, true);
    if (workgroupData) {
        dispatch(setManageWorkgroupDetails(workgroupData.payload || []));
        dispatch(setSubmitWorkgroupListMsg({
            message: '',
            responseStatus: '',
        }));
    } else {
        console.error('Cannot get manage workgroup details', url);
    }
};

export const getAllTags = () => async dispatch => {
    const url = endpoints.TICKET_MGMT_WORKGROUPS_ALL_TAGS;
    const allTags = await API.getData(url, dispatch, actions, true);
    if (allTags) {
        dispatch(setWorkgroupAllTags(allTags.payload || []));
    } else {
        console.error('Cannot get manage workgroup all tags', url);
    }
};

export const getFilteredWorkgroupdData =
    (containsTag: boolean = false, tag?: string, workgroupName?: string) =>
        async dispatch => {
            
            let searhWorkgroupApiURL = `${endpoints.TICKET_MGMT_WORKGROUPS_LIST}?containsTag=${containsTag}`;
            if (tag && workgroupName) {
                searhWorkgroupApiURL = `${searhWorkgroupApiURL}&tag=${tag}&workgroup=${workgroupName}`;
            } else if (tag) {
                searhWorkgroupApiURL = `${searhWorkgroupApiURL}&tag=${tag}`;
            } else if (workgroupName) {
                searhWorkgroupApiURL = `${searhWorkgroupApiURL}&workgroup=${workgroupName}`;
            } 

            const searchFilteredData = await API.getData(searhWorkgroupApiURL, dispatch, actions, true);
            if (searchFilteredData) {
                dispatch(setManageWorkgroupDetails(searchFilteredData.payload || []));
            } else {
                console.error('Cannot get manage workgroup searched filtered data', searhWorkgroupApiURL);
            }
        };

export const saveNewWorkgroup = ( workGroupName: string ) => async dispatch => {
    const url = endpoints.TICKET_MGMT_WORKGROUPS_SAVE_NEW_WORKGROUP;
    const payload = new FormData();
    const body = {
        name: workGroupName,
        isDefault: IS_DEFAULT_WORKGROUP.NO,
        id: '',
        roleId: '',
        csrftoken: window.csrf_token
    };

    for (const [key, value] of Object.entries(body)) {
        payload.append(key, value);
    }

    const params = [url, payload, 'POST', true, undefined, 'application/x-www-form-urlencoded'];
    try {
        const response = await API.postData(params, dispatch, actions);
        if (response.statusCode === 200) {
            dispatch(fetchManageWorkgroupDetails());
            dispatch(getAllTags());
        } else {
            throw new Error(`Failed to save new workgroup, url: ${url}`);
        }
    } catch (error) {
        dispatch(stopSpinner());
        return Promise.reject(error);
    }
};

export const submitWorkgroupListChanges =
    (queueIds: string) => async dispatch => {
        const url = endpoints.TICKET_MGMT_WORKGROUPS_SAVE_DEFAULT_QUEUE;
        const payload = new FormData();
        payload.append('queueIds', queueIds);
        payload.append('csrftoken', window.csrf_token);

        const params = [ url, payload, 'POST', true, undefined, 'application/x-www-form-urlencoded' ];
        try {
            const response = await API.postData(params, dispatch, actions);
            if (response.statusCode === 200) {
                dispatch(setSubmitWorkgroupListMsg({
                    message: 'ticket_management.manage_workgroup.table.workgroup.form.save.success',
                    responseStatus: RESPONSE_STATUS.SUCCESS,
                }));
                dispatch(fetchManageWorkgroupDetails());
                dispatch(getAllTags());
            } else {
                dispatch(setSubmitWorkgroupListMsg({
                    message: 'ticket_management.manage_workgroup.table.workgroup.form.save.error',
                    responseStatus: RESPONSE_STATUS.FAILURE,
                }));
                throw new Error(`Failed to submit workgroup list changes, url: ${url}`);
            }
        } catch (error) {
            dispatch(stopSpinner());
            dispatch(setSubmitWorkgroupListMsg({
                message: 'ticket_management.manage_workgroup.table.workgroup.form.save.error',
                responseStatus: RESPONSE_STATUS.FAILURE,
            }));
            return Promise.reject(error);
        }
    };


export const getWorkgroupNameSuggestions = (searchWorkgroupName?: string) => async dispatch => {
    const url = endpoints.TICKET_MGMT_WORKGROUPS_SEARCH_WORKGROUP_NAMES.processReplacements({
        workgroupName: searchWorkgroupName,
    });

    if (!searchWorkgroupName || searchWorkgroupName.length < 3) {
        return [];
    }
            
    const response = await API.getData(url, dispatch, actions, false);
    
    if (response) {
        return response;
    } else {
        console.error('Cannot get workgroup names', url);
        return [];
    }       
};